import Link from '@components/common/Link/Link'
import Button from '@components/ui/ButtonV2/Button'
import ContainerV2 from '@components/ui/ContainerV2/ContainerV2'
import Media from '@components/ui/Media/Media'

import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import {
  M46Fragment,
  StoriesBlockListElementTypeFragment,
} from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { FC } from 'react'
import s from './M46.module.scss'
export interface M46Props extends M46Fragment {}
const M46: FC<M46Props> = ({
  richTextHeadline,
  headline,
  exploreAll,
  stories,
}) => {
  return (
    <ContainerV2>
      <div className={s.root}>
        {richTextHeadline ? (
          <TrustedHtml html={richTextHeadline} />
        ) : (
          headline && <h2 className={s.headline}>{headline}</h2>
        )}
        <div className={s.stories}>
          {stories?.map((story: StoriesBlockListElementTypeFragment, index) => (
            <Link key={index} className={s.storyWrapper} link={story.link}>
              <span className={s.storyMediaWrapper}>
                <Media
                  mediaWithCrops={story.image}
                  mediaClassName={s.storyMedia}
                  scaleOnHover
                  sizes="(max-width: 834px) 133px, (min-width: 1512px) 435px, 30vw "
                  disableShopTheLook
                />
              </span>

              <div className={s.storyContent}>
                <h3 className={s.storyHeadline}>
                  <span className={clsx(s.underlineAnimation)}>
                    <TrustedHtml
                      html={story.headline.replace(/<[^>]*>/g, '')}
                    />
                  </span>
                </h3>
                <span className={s.storyBodyText}>
                  {story.bodyText.replace(/<[^>]*>/g, '')}
                </span>
              </div>
            </Link>
          ))}
        </div>
        {exploreAll && (
          <span className={s.exploreButton}>
            <Button size="medium" as={Link} link={exploreAll}>
              {exploreAll?.name}
            </Button>
          </span>
        )}
      </div>
    </ContainerV2>
  )
}

export default M46
